var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDongSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 400C222.416 400 250.014 388.896 272 371.111V376C272 389.25 282.75 400 296 400S320 389.25 320 376V112H328C341.25 112 352 101.25 352 88S341.25 64 328 64H320V56C320 42.75 309.25 32 296 32S272 42.75 272 56V64H216C202.75 64 192 74.75 192 88S202.75 112 216 112H272V172.889C250.014 155.104 222.416 144 192 144C121.422 144 64 201.406 64 272S121.422 400 192 400ZM192 192C236.109 192 272 227.875 272 272S236.109 352 192 352S112 316.125 112 272S147.891 192 192 192ZM360 432H24C10.75 432 0 442.75 0 456S10.75 480 24 480H360C373.25 480 384 469.25 384 456S373.25 432 360 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDongSign);
export default __webpack_public_path__ + "static/media/dong-sign.66f5ec137cb6707087f923f94f5744ac.svg";
export { ForwardRef as ReactComponent };